import { apiClient } from '@/modules/shared/services/apiClient';
import type { ApiResponse } from '@/modules/shared/types';

export interface ProgramAccessFeatureEntry {
  key: string;
  menuKey: string;
  programEnabled: boolean;
  roleAllowed: boolean;
  effectiveAccess: boolean;
  source: string;
}

export interface ProgramAccessActionEntry {
  key: string;
  featureKey: string;
  programEnabled: boolean;
  roleAllowed: boolean;
  effectiveAccess: boolean;
  source: string;
}

export interface MyProgramAccessDto {
  programId: string;
  programName: string;
  userId: string;
  roleId: string;
  roleName: string;
  roleCategory: string;
  governanceType: string;
  isConfigurationRole: boolean;
  isOperationalRole: boolean;
  defaultLandingRoute: string;
  accessibleMenuKeys: string[];
  features: Record<string, ProgramAccessFeatureEntry>;
  actions: Record<string, ProgramAccessActionEntry>;
}

export const PROGRAM_FEATURE_KEYS = {
  PROGRAM_DASHBOARD: 'PROGRAM_DASHBOARD',
  WORKSPACE: 'WORKSPACE',
  HOSPITALS: 'HOSPITALS',
  HCPS: 'HCPS',
  PATIENTS: 'PATIENTS',
  PATIENT_360: 'PATIENT_360',
  CREATE_ASSISTANCE_CASE: 'CREATE_ASSISTANCE_CASE',
  ASSISTANCE_CASES: 'ASSISTANCE_CASES',
  ASSISTANCE_CLAIMS: 'ASSISTANCE_CLAIMS',
  CALL_LOGS: 'CALL_LOGS',
  ADVERSE_EVENTS: 'ADVERSE_EVENTS',
  REPORTS: 'REPORTS',
  AUDIT_REPORT: 'AUDIT_REPORT',
  ROLES_CONFIG: 'ROLES_CONFIG',
  USERS_CONFIG: 'USERS_CONFIG',
  FORMS_CONFIG: 'FORMS_CONFIG',
  WORKFLOW_CONFIG: 'WORKFLOW_CONFIG',
  ASSISTANCE_SETTINGS: 'ASSISTANCE_SETTINGS',
  FINANCIAL_PLAN: 'FINANCIAL_PLAN',
  NOTIFICATIONS_CONFIG: 'NOTIFICATIONS_CONFIG',
  AUTOMATION_RULES: 'AUTOMATION_RULES',
  UI_SETTINGS: 'UI_SETTINGS',
  ROLE_FORM_WORKFLOW_MAPPING: 'ROLE_FORM_WORKFLOW_MAPPING',
  LEGAL_PAGES: 'LEGAL_PAGES',
} as const;

// Re-export PROGRAM_ACTION_KEYS from the centralized registry for backward compatibility
// New code should import directly from permissionRegistry.ts
export { PROGRAM_ACTION_KEYS } from '../constants/permissionRegistry';

export const programAccessService = {
  async getMyProgramAccess(programId: string): Promise<ApiResponse<MyProgramAccessDto>> {
    const res = await apiClient.get<ApiResponse<MyProgramAccessDto>>(`/programs/${programId}/access/me`);
    return res.data;
  },
};